import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getCompanyListSucceed, requestFailure } from '../actions'

export function* getCompanyListSaga(
  companyApi: {
    getCompanyList: (...args: any[]) => any
  },
  {
    payload: { page, limit, q, sortBy, sortDirection }
  }: {
    payload: {
      page: number
      limit: number
      q: string
      sortBy: string
      sortDirection: string
    }
  }
) {
  try {
    const { data } = yield call(
      companyApi.getCompanyList,
      page,
      limit,
      q,
      sortBy,
      sortDirection
    )
    yield put(getCompanyListSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
